
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowsV, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
import { qprService } from '../../../Services';
import { qprActions } from '../../../Actions';
import {formatDate} from '../../../Helpers';

const Show = (prop) => {
  // const location = useLocation();
  // const { qpr_id, qh } = location.state;
  const { qpr_id, qh } = prop;
  let qpr = useSelector((state) => state.qpr_data);
  const [qpr_data, setQprData] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selected_file, setSelectedFile] = useState(null);

  useEffect(async () => {
    if(qpr_id) {
      if(typeof qpr.basic_information == "undefined" || qpr.basic_information.id!=qpr_id) {
        localStorage.removeItem("qpr_data");
        qpr = {};
        dispatch(qprActions.qprData(qpr));
        await qprService.basicInformation(qpr_id).then(rslt => {
          if(rslt.status == 404) {
            navigate("/logout");
          }
          qpr.basic_information = rslt.data.basic_information;
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
        });
      }
  
      if(typeof qpr.research_background == "undefined") {
        await qprService.researchBackground(qpr_id).then(rslt => {
          qpr.research_background = rslt.data.research_background;
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
        });
      }

      if(qpr.basic_information.quarter>1 && typeof qpr.response_to_te == "undefined") {
        await qprService.responseToTE(qpr_id).then(rslt => {
          qpr.response_to_te = rslt.data.response_to_te;
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
        });
      }
  
      if(typeof qpr.progress_report == "undefined") {
        await qprService.progressReport(qpr_id).then(rslt => {
          qpr.progress_report = rslt.data.progress_report;
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
        });
      }

      if(qpr.basic_information.quarter>1 && typeof qpr.progress_ppt == "undefined") {
        await qprService.progressPPT(qpr_id).then(rslt => {
          qpr.progress_ppt = rslt.data.progress_ppt;
          qpr.form_validation = JSON.parse(rslt.data.progress_ppt.form_validation);
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
          setQprData(qpr);
        });
      }
  
      if(typeof qpr.plan_for_remaining_quarter == "undefined") {
        await qprService.planForRemainingQuarter(qpr_id).then(rslt => {
          qpr.plan_for_remaining_quarter = rslt.data.plan_for_remaining_quarter;
          qpr.form_validation = JSON.parse(rslt.data.plan_for_remaining_quarter.form_validation);
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
        });
      }
  
      if(typeof qpr.project_gantt_chart == "undefined") {
        await qprService.projectGanttChart(qpr_id).then(rslt => {
          qpr.project_gantt_chart = rslt.data.project_gantt_chart;
          qpr.form_validation = JSON.parse(rslt.data.project_gantt_chart.form_validation);
          localStorage.setItem("qpr_data", JSON.stringify(qpr));
          dispatch(qprActions.qprData(qpr));
          setQprData(qpr);
        });
      }
    }
  }, []);

  const MyModal = () => {
    return (
      <>
        <div className={"modal fade"} id="myModal">
          <div className="modal-dialog modal-dialog-scrollable modal-lg">
            <div className="modal-content">
            
              <div className="modal-header">
                {/* <h1 className="modal-title">Modal Heading</h1> */}
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
                {selected_file && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/uploads"+selected_file },
                      // { uri: require(selected_file) }, // Local File
                    ]
                  } 
                />
                }
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }
  return (
    <>
      {/* <section className="pt-3 pb-3 border-top content-min-height">
        <div className="container">
          <div className="card border-success"> 
            <div className="card-header bg-light p-2 border-success" style={{"borderTop": "3px solid"}}><h4>{qh}</h4></div> */}
            <div className="card-body">
              <div className=''>
                <div className='border p-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#bi">
                    <div className='col-md-11'>
                      <h5>Basic Information</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className='collapse show' id='bi'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <table className='table table-borderless'>
                          <thead>
                            <tr>
                              <th><h6>Team Member(s):</h6></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {qpr.basic_information && qpr.basic_information.name.split("|").map((val, key) => {
                                  return(
                                    <div key={key}>
                                      <p className='pl-3'>{val}</p>
                                    </div>
                                  );
                                })}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-6'>
                        <table className='table table-borderless'>
                          <thead>
                            <tr>
                              <th className='border-bottom' colSpan={3}><h6>Status of Grant:</h6></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Sanctioned amount</td>
                              <td>:</td>
                              <td>${qpr.basic_information && qpr.basic_information.sanctioned_amount}</td>
                            </tr>
                            <tr>
                              <td>Date of fund received</td>
                              <td>:</td>
                              <td>{qpr.basic_information && formatDate(qpr.basic_information.fund_received_date)}</td>
                            </tr>
                            <tr>
                              <td>Status of expenditure</td>
                              <td>:</td>
                              <td>{qpr.basic_information && qpr.basic_information.expenditure_status}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className='col-md-6'>
                        <table className='table table-borderless'>
                          <thead>
                            <tr>
                              <th className='border-bottom' colSpan={3}><h6>Mentor Info:</h6></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Name</td>
                              <td>:</td>
                              <td>{qpr.basic_information && qpr.basic_information.mentor_name}</td>
                            </tr>
                            <tr>
                              <td>Email</td>
                              <td>:</td>
                              <td>{qpr.basic_information && qpr.basic_information.mentor_email}</td>
                            </tr>
                            <tr>
                              <td>Organization</td>
                              <td>:</td>
                              <td>{qpr.basic_information && qpr.basic_information.mentor_organization}</td>
                            </tr>
                            <tr>
                              <td>Designation</td>
                              <td>:</td>
                              <td>{qpr.basic_information && qpr.basic_information.mentor_designation}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr />
                    <div className='row'>
                      <div className='col-md-12'>
                        <table className='table table-borderless'>
                          <thead>
                            <tr>
                              <th><h6>Title of research:</h6></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{qpr.basic_information && qpr.basic_information.research_title}</td>
                            </tr>
                            {qpr.basic_information && qpr.basic_information.quarter>1 && 
                            <tr>
                              <td>Period of Report:&nbsp;
                                <span className='badge badge-info'>
                                  {qpr.basic_information && formatDate(qpr.basic_information.report_start_date)}
                                </span>
                                &nbsp;To&nbsp; 
                                <span className='badge badge-info'>
                                  {qpr.basic_information && formatDate(qpr.basic_information.report_end_date)}
                                </span>
                              </td>
                            </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='mt-3'>
                <div className='border p-2 mt-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#rb">
                    <div className='col-md-11'>
                      <h5>Research background</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className='mt-2 collapse' id='rb'>
                    <div className='col-md-12 p-2 border'>
                      <h6>Research Objective:</h6>
                      <p>{qpr.research_background && qpr.research_background.research_objective}</p>
                    </div>
                    <div className='col-md-12 p-2 border'>
                      <h6>Expected Outcomes of Research:</h6>
                      <p>{qpr.research_background && qpr.research_background.expected_outcome}</p>
                    </div>
                    <div className='col-md-12 p-2 border'>
                      <h6>Deviation/changes if any from the original proposal:</h6>
                      <p>{qpr.research_background && qpr.research_background.deviation}</p>
                    </div>
                  </div>
                </div>
              </div>
              {qpr.response_to_te && qpr.response_to_te.quarter>1 &&
              <div className='mt-3'>
                <div className='border p-2 mt-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#rtte">
                    <div className='col-md-11'>
                      <h5>Response To Technical Expert</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className='mt-2 collapse' id='rtte'>
                    {qpr.response_to_te && qpr.response_to_te.rtte.map((val, key) => {
                      return (
                        <div className='col-md-12 border' key={key}>
                          <p><strong>{val.title} {val.full_name}:</strong> {val.recommendation}</p>
                          <p>{val.fellow_response}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              }
              <div className='mt-3'>
                <div className='border p-2 mt-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#pr">
                    <div className='col-md-11'>
                      <h5>Progress Report</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className='mt-2 collapse' id='pr'>
                    <div className='border p-2'>
                      <h6>Planned vs Achieved Progress in the Quarter:</h6>
                      <div className='col-md-12 mt-3'>
                        <h6>What activities were planned for this quarter?:</h6>
                        <p>{qpr.progress_report && qpr.progress_report.activity_planned}</p>
                      </div>
                      <div className='col-md-12 mt-3'>
                        <h6>What is the current status of the planned activities?:</h6>
                        <p>{qpr.progress_report && qpr.progress_report.planned_activity_status}</p>
                      </div>
                      <div className='col-md-12 mt-3'>
                        <h6>What are the reasons for under/non-performance?:</h6>
                        <p>{qpr.progress_report && qpr.progress_report.non_performance_reason}</p>
                      </div>
                      <div className='col-md-12 mt-3'>
                        <h6>In case of delay or under/non-performance, what is the plan for completing the project on time?:</h6>
                        <p>{qpr.progress_report && qpr.progress_report.non_performance_project_plan}</p>
                      </div>
                      <div className='col-md-12 mt-3'>
                        <h6>Summary report of progress:</h6>
                        <p>{qpr.progress_report && qpr.progress_report.progress_summery}</p>
                      </div>
                    </div>
                    {/* <div className='border p-2'>
                      <h6>Research papers published/accepted/submitted for publication during the quarter:</h6>
                      <div className='row'>
                        <div className='col-md-6'>
                          <table className='table table-borderless'>
                            <tbody>
                              <tr>
                                <td>Author name</td>
                                <td>:</td>
                                <td>{qpr.progress_report && qpr.progress_report.author_name}</td>
                              </tr>
                              <tr>
                                <td>Title of the paper</td>
                                <td>:</td>
                                <td>{qpr.progress_report && qpr.progress_report.paper_title}</td>
                              </tr>
                              <tr>
                                <td>Journal/ Conference/ Workshop</td>
                                <td>:</td>
                                <td>{qpr.progress_report && qpr.progress_report.journal}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className='col-md-6'>
                          <table className='table table-borderless'>
                            <tbody>
                              <tr>
                                <td>Volume</td>
                                <td>:</td>
                                <td>{qpr.progress_report && qpr.progress_report.volume}</td>
                              </tr>
                              <tr>
                                <td>Year</td>
                                <td>:</td>
                                <td>{qpr.progress_report && qpr.progress_report.year}</td>
                              </tr>
                              <tr>
                                <td>Page number</td>
                                <td>:</td>
                                <td>{qpr.progress_report && qpr.progress_report.page_number}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div> */}
                    <div className='border p-2'>
                      <h6>Please provide any research papers/conferences/patents submitted or published:</h6>
                      <p>{qpr.progress_report && qpr.progress_report.research_paper}</p>
                    </div>
                    <div className='border p-2'>
                      <h6>Please share the link of images or videos captured during project experiments, field work, stakeholder engagement etc:</h6>
                      <p>{qpr.progress_report && qpr.progress_report.other_update}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='mt-3'>
                <div className='border p-2 mt-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#pp">
                    <div className='col-md-11'>
                      <h5>Progress PPT</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className="row collapse" id="pp">
                    {qpr.progress_ppt && qpr.progress_ppt.pp.map((val, key) => {
                      return (
                        <div className='col-md-6 mt-2' key={key}>
                          <div className="media border p-2" style={{height: "100px"}}>
                            <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} data-toggle="modal" data-target="#myModal" onClick={() => setSelectedFile(val.chart)} />
                            <div className="media-body pl-2">
                              <p className='text-wrap' style={{width:"470px"}}>{val.name}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className='mt-3'>
                <div className='border p-2 mt-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#pfrq">
                    <div className='col-md-11'>
                      <h5>Plan For Remaining Quarters</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className='mt-2 collapse' id='pfrq'>
                    {qpr.plan_for_remaining_quarter && qpr.plan_for_remaining_quarter.prq.map((val, key) => {
                      return (
                        <div className='col-md-12 border' key={key}>
                          <p><strong>Timeline:</strong> {val.timeline}</p>
                          <p><strong>Planned Activities:</strong> {val.planned_activities}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className='mt-3'>
                <div className='border p-2 mt-2'>
                  <div className='row pointer' data-toggle="collapse" data-target="#pgc">
                    <div className='col-md-11'>
                      <h5>Project Gantt Chart</h5>
                    </div>
                    <div className='col-md-1 text-right'>
                      <FontAwesomeIcon icon={faArrowsV} />
                    </div>
                  </div>
                  <div className="row collapse" id="pgc">
                    {qpr.project_gantt_chart && qpr.project_gantt_chart.pgc.map((val, key) => {
                      return (
                        <div className='col-md-6 mt-2' key={key}>
                          <div className="media border p-2" style={{height: "100px"}}>
                            <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} data-toggle="modal" data-target="#myModal" onClick={() => setSelectedFile(val.chart)} />
                            <div className="media-body pl-2">
                              <p className='text-wrap' style={{width:"470px"}}>{val.name}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          {/* </div>
        </div>
      </section> */}
      <MyModal />
    </>
  );
};

export default Show;